import type { RoomEditedField } from 'app/typings/core/extranet/inventory/enums/RoomEditedField';
import { ROOM_EDITED_FIELDS } from 'app/typings/core/extranet/inventory/enums/RoomEditedField';

export type EditedRoomFields = Record<
  string,
  Record<number, RoomEditedField[]>
>;

export const mapFormFieldToEditedField = (
  field: string | number
): RoomEditedField | undefined => {
  switch (field) {
    case 'price':
      return ROOM_EDITED_FIELDS.PRICE;
    case 'discountPrice':
      return ROOM_EDITED_FIELDS.DISCOUNT_PRICE;
    case 'discount':
      return ROOM_EDITED_FIELDS.DISCOUNT;
    case 'remainingStock':
      return ROOM_EDITED_FIELDS.STOCK;
    case 'isClosedByHotel':
    case 'isClosedByStaycation':
      return ROOM_EDITED_FIELDS.CLOSED;
    default:
      return undefined;
  }
};

const DISCOUNT_EDITED_FIELDS: RoomEditedField[] = [
  ROOM_EDITED_FIELDS.DISCOUNT,
  ROOM_EDITED_FIELDS.DISCOUNT_PRICE,
];

export const appendEditedField = (
  editedFields: RoomEditedField[],
  field: RoomEditedField
): RoomEditedField[] => {
  const conflictingFields = DISCOUNT_EDITED_FIELDS.includes(field)
    ? DISCOUNT_EDITED_FIELDS
    : [field];

  return [...editedFields.filter((f) => !conflictingFields.includes(f)), field];
};

export const isBarOnlyEdit = (editedFields?: RoomEditedField[]): boolean =>
  editedFields !== undefined &&
  editedFields.length > 0 &&
  editedFields.every((field) => field === ROOM_EDITED_FIELDS.PRICE);

export const deriveBulkEditFields = (fields: {
  stock?: number;
  price?: number;
  discount?: number;
  discountPrice?: number;
}): RoomEditedField[] => {
  const editedFields: RoomEditedField[] = [];

  if (fields.stock !== undefined) {
    editedFields.push(ROOM_EDITED_FIELDS.STOCK);
  }

  if (fields.price !== undefined) {
    editedFields.push(ROOM_EDITED_FIELDS.PRICE);
  }

  if (fields.discount !== undefined) {
    editedFields.push(ROOM_EDITED_FIELDS.DISCOUNT);
  }

  if (fields.discountPrice !== undefined) {
    editedFields.push(ROOM_EDITED_FIELDS.DISCOUNT_PRICE);
  }

  return editedFields;
};

export const deriveEditedFieldsFromRoomData = (roomData: {
  remainingStock?: number;
  price?: number;
  discountPrice?: number;
  isClosedByHotel?: boolean;
  isClosedByStaycation?: boolean;
}): RoomEditedField[] => {
  const editedFields: RoomEditedField[] = [];

  if (roomData.remainingStock !== undefined) {
    editedFields.push(ROOM_EDITED_FIELDS.STOCK);
  }

  if (roomData.price !== undefined) {
    editedFields.push(ROOM_EDITED_FIELDS.PRICE);
  }

  if (roomData.discountPrice !== undefined) {
    editedFields.push(ROOM_EDITED_FIELDS.DISCOUNT_PRICE);
  }

  if (
    roomData.isClosedByHotel !== undefined ||
    roomData.isClosedByStaycation !== undefined
  ) {
    editedFields.push(ROOM_EDITED_FIELDS.CLOSED);
  }

  return editedFields;
};
